import { URLConstants as a, LocalStorageUtils as o, LocalStorageConstants as r, AppIDConstants as U, URLUtils as h, WebSocketUtils as v } from "@deriv-com/utils";
const I = "https://oauth.deriv.com/oauth2/sessions/logout", L = "https://oauth.deriv.com", m = {
  [a.derivP2pProduction]: "blue.derivws.com",
  [a.derivP2pStaging]: "red.derivws.com"
}, c = () => {
  const e = window.location.origin, t = window.location.hostname, { getAppId: n } = v, l = n(), g = o.getValue(r.configAppId), u = o.getValue(r.configServerURL);
  e === a.derivP2pStaging && (!g || !u) && (o.setValue(
    r.configServerURL,
    m[e]
  ), o.setValue(
    r.configAppId,
    `${U.domainAppId[t]}`
  ));
  const i = o.getValue(r.configServerURL) || localStorage.getItem("config.server_url");
  let s = "oauth.deriv.com";
  i && /qa/.test(String(i)) ? s = i : t.includes(".deriv.me") ? s = "oauth.deriv.me" : t.includes(".deriv.be") && (s = "oauth.deriv.be");
  const p = o.getValue(r.configAppId) || l, d = o.getValue(r.i18nLanguage);
  return {
    appId: p,
    lang: d,
    serverUrl: s
  };
}, f = () => {
  const { appId: e, lang: t, serverUrl: n } = c();
  return e && n ? `https://${n}/oauth2/authorize?app_id=${e}&l=${t ?? "EN"}&brand=deriv` : h.getOauthURL();
}, A = () => {
  const { appId: e, serverUrl: t } = c();
  return e && t ? `https://${t}/oauth2/sessions/logout` : I;
}, O = () => {
  const { appId: e, serverUrl: t } = c();
  return e && t ? `https://${t}` : L;
};
export {
  I as DEFAULT_OAUTH_LOGOUT_URL,
  L as DEFAULT_OAUTH_ORIGIN_URL,
  A as getOAuthLogoutUrl,
  O as getOAuthOrigin,
  f as getOauthUrl,
  c as getServerInfo
};
